import React from 'react'
import { Box, Stack, FormControl, FormHelperText, Input, Button, Text } from '@chakra-ui/react'
import DatePicker from 'react-datepicker'

export default function DatetimeInput ({ dataType, value, onChange }) {
  return (
    <Box>
      <FormControl>
        <Stack direction='row' spacing={2}>
          <Box maxW='300px'>
            <DatePicker
              placeholderText='Tap to select a date & time...'
              showTimeSelect
              showMonthDropdown
              showYearDropdown
              dropdownMode='select'
              todayButton='Today'
              dateFormat='dd/MM/yyyy HH:mm'
              selected={value ? new Date(value) : null}
              onChange={(date) => {
                onChange(date ? date.toISOString() : '')
              }}
              customInput={<Input bg='white' />}
            />
          </Box>
          {value && <Button ml={2} onClick={e => onChange(null)}>Clear date</Button>}
        </Stack>
        <FormHelperText>
          {value &&
            <Stack spacing={2} direction='row'>
              {dataType.earliestDate && <Text mr={4} color={value < dataType.earliestDate ? 'red' : 'black'}>Earliest allowed: {dataType.earliestDate}</Text>}
              {dataType.latestDate && <Text color={value > dataType.latestDate ? 'red' : 'black'}>Latest allowed: {dataType.latestDate}</Text>}
            </Stack>}
        </FormHelperText>
      </FormControl>
    </Box>
  )
}
